module.exports = __webpack_public_path__ + "img/themes.1b85597b.svg";